import React, { useState } from 'react';

import styles from './new_conversation_room.module.css';

const formatRelativeTime = (value) => {
  const timestamp = new Date(value).getTime();
  if (Number.isNaN(timestamp)) return null;

  const diffSeconds = Math.max(1, Math.round((Date.now() - timestamp) / 1000));
  if (diffSeconds < 60) return `${diffSeconds}s`;

  const diffMinutes = Math.round(diffSeconds / 60);
  if (diffMinutes < 60) return `${diffMinutes}m`;

  const diffHours = Math.round(diffMinutes / 60);
  if (diffHours < 24) return `${diffHours}h`;

  const diffDays = Math.round(diffHours / 24);
  if (diffDays < 30) return `${diffDays}d`;

  const diffMonths = Math.round(diffDays / 30);
  if (diffMonths < 12) return `${diffMonths}mo`;

  return `${Math.round(diffMonths / 12)}y`;
};

export default function ConversationsListItem({ selectedConversation, conversation }) {
  const hasUnreadMessages = conversation.unread_messages > 0;
  const otherProfile = conversation.other_user_conversations[0]?.profile || {};
  const imageUrl = otherProfile.photo || '';
  const [imageFailed, setImageFailed] = useState(false);
  const displayName = otherProfile.display_name || 'Community member';
  const latestMessage = conversation.messages[conversation.messages.length - 1];
  const latestMessageTime = latestMessage ? formatRelativeTime(latestMessage.created_at) : null;
  const initials = displayName
    .split(' ')
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className={`${styles.message_in_list} ${conversation.uuid === selectedConversation ? styles.selected : ''}`}>
      <div className={styles.conversation_avatar_wrap}>
        {imageUrl && !imageFailed ? (
          <div className={styles.chat_room_pp_avatar}>
            <img src={imageUrl} alt='' draggable='false' onError={() => setImageFailed(true)} />
          </div>
        ) : (
          <div className={styles.chat_room_pp_avatar_initials}>{initials || 'PP'}</div>
        )}
        {hasUnreadMessages && (
          <span className={styles.conversation_unread_count}>
            {conversation.unread_messages > 9 ? '9+' : conversation.unread_messages}
          </span>
        )}
      </div>

      <div className={styles.conversation_item_body}>
        <div className={styles.conversation_item_top}>
          <p
            className={`${styles.conversation_item_name} ${hasUnreadMessages ? styles.conversation_item_name_unread : ''}`}
          >
            {displayName}
          </p>
          {latestMessageTime && <p className={styles.chat_room_pp_created_at}>{latestMessageTime}</p>}
        </div>

        <div className={styles.chat_room_message_wrap}>
          <p
            className={`${styles.chat_room_last_message} ${hasUnreadMessages ? styles.chat_room_last_message_unread : ''}`}
          >
            {latestMessage
              ? latestMessage.body
              : "No messages yet. Once you're matched with a mentor, you can message them here."}
          </p>
          {hasUnreadMessages && <div className={styles.new_messages_dot} />}
        </div>
      </div>
    </div>
  );
}
